import { render, staticRenderFns } from "./UserBanner.vue?vue&type=template&id=8d554ca4&scoped=true&"
import script from "./UserBanner.vue?vue&type=script&lang=js&"
export * from "./UserBanner.vue?vue&type=script&lang=js&"
import style0 from "./UserBanner.vue?vue&type=style&index=0&id=8d554ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d554ca4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VSpacer,VToolbarTitle})
